import { request } from "../../api/api"


export const getScannedPipesHistory = (page, pageSize, filters, extraParams) => {
  const params = {
    page: page + 1,
    page_size: pageSize,
  };

  if (filters.status) params.status = filters.status;
  if (filters.firstName) params.tested_by__first_name__icontains = filters.firstName;
  if (filters.lastName) params.tested_by__last_name__icontains = filters.lastName;
  if (filters.uid) params.uid__original_uid__icontains = filters.uid;
  if (filters.product) params.product__product_name__icontains = filters.product;
  if (filters.size) params.size__size__icontains = filters.size;
  if (filters.scanBy) params.tested_by__user_role__name__icontains = filters.scanBy;
  if (filters.location) params.location__icontains = filters.location;
  if (filters.device) params.device_type__icontains = filters.device;
  if (filters.dateTime) params.created_at = filters.dateTime;
  if (filters.mobileNumber) params.tested_by__mobile_number__icontains = filters.mobileNumber;

  Object.assign(params, extraParams);

  return request.get(`dashboard/getScannedPipesHistory/`, { params });
};

  

  export const getScannedPipesCount =(data)=>{
    return request.post(`dashboard/getScannedPipesCount/`,data)
  }
  export const getProductCount =(data)=>{
    return request.post(`dashboard/getProductCount/`,data)
  }
  export const getScanbyUserRoleCount =(data)=>{
    return request.post(`dashboard/getScanbyUserRoleCount/`,data)
  }
  export const getDeviceTypesCount =(data)=>{
    return request.post(`dashboard/getDeviceTypesCount/`,data)
  }
  export const getDailyScanPatternsCounts =(data)=>{
    return request.post(`dashboard/getDailyScanPatternsCounts/`,data)
  }


  export const getTopCrossSellingLocations =(data)=>{
    return request.post(`dashboard/getTopCrossSellingLocations/`,data)
  }

  export const getLocationsForMap =(data)=>{
    return request.post(`dashboard/getLocationsForMap/`,data)
  }

  export const getTopCounterfeitLocations =(data)=>{
    return request.post(`dashboard/getTopCounterfeitLocations/`,data)
  }
  export const getProduct =()=>{
    return request.get(`detailed_analytics/getProduct/`)
  }
  export const getSize =()=>{
    return request.get(`detailed_analytics/getSize/`)
  }
  export const getLocationList =()=>{
    return request.get(`dashboard/getLocationList`)
  }
  export const getProductOverProductBarGraph =(data)=>{
    return request.post(`detailed_analytics/getProductOverProductBarGraph/`,data)
  }
  export const getUserRoleList =()=>{
    return request.get(`dashboard/getUserRoleList/`)
  }


  /* Product detail page  */

  export const getProductSizeCounts = (data) => {
    return request.post(`detailed_analytics/getProductSizeCounts/`, data);
  }

  export const getProductSizePercentageCounts = (data) => {
    return request.post(`detailed_analytics/getProductSizePercentageCounts/`, data);
  }

  export const getProductLocationBasedSizeCounts = (data) => {
    return request.post(`detailed_analytics/getProductLocationBasedSizeCounts/`, data);
  }

  export const getProductScanByUserRoleCounts = (data) => {
    return request.post(`detailed_analytics/getProductScanByUserRoleCounts/`, data);
  }

  export const getTop5CrossORCounterGraphCount = (data) => {
    return request.post(`detailed_analytics/getTop5CrossORCounterGraphCount/`, data);
  }

  export const getNearbyDistributors = (data) => {
    const queryParams = new URLSearchParams();
    
    if (data?.city) {
        queryParams.append("city", data.city);
    } else if (data?.state) {
        queryParams.append("state", data.state);
    }
    
    return request.get(`dashboard/getNearbyDistributors/?${queryParams.toString()}`);
}

  export const getNearByMapCounts = (data) => {
    return request.post(`dashboard/getNearByMapCounts/`, data);
  }

  export const getDashboardInsights = (data)  => {
    return request.post(`dashboard/getDashboardInsights/`, data);
  }

  /* UID location search */
  export const getTracking = (data) => {
    return request.post(`dashboard/getWebTracking/`, data);
  }

   /* Pipes export excel */

   export const exportScannedPipeHistoryExcel = (data) => {
    return request.post(`dashboard/exportScannedPipeHistoryExcel/`, data);
   }
